import React, { useEffect, useState } from "react";
import "./viewFirstScreen.css";
import { useLocation, useNavigate } from "react-router-dom";
// import ChannelBoxProps from "../../Empty_Screen/Channels_List/ChannelBoxProps";
import ChannelBox from "../../Empty_Screen/Channels_List/ChannelBox";
import DeleteChnnelConfir from "../Deleete_confir_channel/DeleteChnnelConfir";
// import ChannelPost from "../Vew_Channel_Post/ChannelPost";
import AboutChannel from "../View_About_Channel/AboutChannel";
import ChannelMember from "../View_Channel_Member/ChannelMember";
import axios from "../../../../../axios";
import CreateChannelFirst from "../../Create_channel_screen/CreateChannelFirst";
import CreatePostFirst from "../../../Open_community/Create_Post_screen/CreatePostFirst";
import SinglePostImage from "../../../Open_community/total_community_post/recent_post Img/SinglePostImage";
import SingleChannelRequest from "../View_channel_Requ/SingleChannelRequest";
import { Popup } from "semantic-ui-react";
import { IP } from "../../../../../internalServer";
import assets from "../../../../../assets/assets";
import { toast } from "react-toastify";

const ViewFirstScreen = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("About");
  const [clickDelete, setClickDelete] = useState(false);
  const [clickPost, setClickPost] = useState(false);
  const [clickCreate, setClickCreate] = useState(false);
  const [postRequestCount, setPostRequestCount] = useState(0);
  const [postCreatedCount, setPostCreatedCount] = useState(0);
  const [rejectedPostCount, setRejectedPostCount] = useState(0);
  const [viewFirstInProgress, setViewFirstInProgress] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [isPostCreated, setIsPostCreated] = useState(false);
  const [isPostDeclined, setIsPostDeclined] = useState(false);
  const [isMemberUpdated, setIsMemberUpdated] = useState(false);
  const [requestPostCountPending, setRequestPostCountPending] = useState(0);
  const [requestPostCountRejected, setRequestPostCountRejected] = useState(0);
  const [reRenderPage, setReRenderPage] = useState(false);
  const [editCommunityDetails, setEditCommunityDetails] = useState({
    community_name: null,
    editingMode: false,
    operationDone: false,
    profilePicture: null,
  });
  const { community_name, editingMode, operationDone, profilePicture } =
    editCommunityDetails;
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isOpenedPopup, setIsOpenedPopup] = useState();
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [communityPost, setCommunityPost] = useState({
    community: {},
    communitybyID: [],
  });
  const { community, communitybyID } = communityPost;
  const [cmtyName, setCmtyName] = useState("");

  //Added this state by Kuldeep
  const { state } = useLocation();
  const getCommuntiy = async () => {
    try {
      const res = await axios.get(
        // `/api/v1/community/get/${state.communityId}?userId=${teacher_id}`
        `/api/v1/community/get/${state.communityId}?isFullFledged=true&userId=${teacher_id}`
      );
      const communitybyID = await axios.get(
        `/api/v1/community/getByUserId/teacher/${teacher_id}`
      );
      res &&
        communitybyID &&
        setCommunityPost({
          community: res.data.data,
          communitybyID: communitybyID.data.data,
        });
      setEditCommunityDetails({
        ...editCommunityDetails,
        community_name: res.data.data.community_name,
      });
      setCmtyName(res.data.data.community_name);

      setViewFirstInProgress(false);
      setPostRequestCount(0);
      setRejectedPostCount(0);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCommuntiy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.communityId, operationDone, isMemberUpdated, community.status]);

  const handleSubmit = async () => {
    if (community_name.trim() === "") {
      window.alert("Name cannot be empty!");
      return;
    }
    setViewFirstInProgress(true);
    try {
      let res = await axios.put(`/api/v1/community/update/${community?.id}`, {
        user_id: teacher_id,
        community_name: community_name,
      });

      res &&
        setEditCommunityDetails({
          ...editCommunityDetails,
          operationDone: !operationDone,
          editingMode: !editingMode,
        });
    } catch (error) {
      console.log(error);
      setViewFirstInProgress(false);
    }
  };

  // const handleProfilePictureChange = async (file) => {
  //   setViewFirstInProgress(!viewFirstInProgress);
  //   let profile_picture = file;

  //   const extension = "." + profile_picture?.name?.split('.')?.pop()?.toLowerCase();

  //   if (!['.jpg', '.png', '.jpeg'].includes(extension)) {
  //     toast.error('Invalid file format!!');
  //     return;
  //   }

  //   try {
  //     if (file) {
  //       const formData = new FormData();
  //       formData.append("name", file.name);
  //       formData.append("uploadCommunityAttachment", file);
  //       try {
  //         const res = await axios.post(
  //           `/api/v1/community/uploadAttachment/teacherId/${teacher_id}`,
  //           formData
  //         );
  //         profile_picture = res.data.data;
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //     let res = await axios.put(`/api/v1/community/update/${community?.id}`, {
  //       user_id: teacher_id,
  //       profile_picture,
  //     });
  //     res &&
  //       setEditCommunityDetails({
  //         ...editCommunityDetails,
  //         operationDone: !operationDone,
  //       });
  //     setViewFirstInProgress(!viewFirstInProgress);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const handleProfilePictureChange = async (file) => {
    setViewFirstInProgress(true);

    if (!file) {
      try {
        const res = await axios.put(
          `/api/v1/community/update/${community?.id}`,
          {
            user_id: teacher_id,
            profile_picture: null,
          }
        );

        if (res) {
          setEditCommunityDetails((prev) => ({
            ...prev,
            operationDone: !prev.operationDone,
          }));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setViewFirstInProgress(false); // Always hide loader
      }
      return;
    }

    const extension = "." + file?.name?.split(".")?.pop()?.toLowerCase();
    if (![".jpg", ".png", ".jpeg"].includes(extension)) {
      toast.error("Invalid file format!!");
      setViewFirstInProgress(false);
      return;
    }

    try {
      let profile_picture = file;

      // Upload the file
      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("uploadCommunityAttachment", file);

      try {
        const res = await axios.post(
          `/api/v1/community/uploadAttachment/teacherId/${teacher_id}`,
          formData
        );
        profile_picture = res.data.data;
      } catch (uploadError) {
        console.log(uploadError);
      }
      const res = await axios.put(`/api/v1/community/update/${community?.id}`, {
        user_id: teacher_id,
        profile_picture,
      });

      if (res) {
        setEditCommunityDetails((prev) => ({
          ...prev,
          operationDone: !prev.operationDone,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setViewFirstInProgress(false);
    }
  };
  const validateFileType = (filePath) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if (
      !allowedExtensions.exec(filePath.name) ||
      filePath.size > 10 * 1024 * 1024
    ) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };
  useEffect(() => {
    let res = localStorage.getItem("TypeClicked");
    setActive(res);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPostDeclined(false);
      setIsPostCreated(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [isPostCreated, isPostDeclined]);

  useEffect(() => {
    const getRequestPend = async () => {
      try {
        const postRequest = await axios.get(
          `/api/v1/community/post/getBystatus/pending/${state.communityId}`
        );
        console.log("postRequestPending", postRequest);
        if (postRequest) {
          // const postRequestData = postRequest.data.data
          const isNotDeletedPost = postRequest.data.data.filter(
            (post) => post.isDeleted !== true
          );
          setRequestPostCountPending(isNotDeletedPost.length);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getRequestPend();
  }, [active, requestPostCountPending, community]);

  return community && community.community_name ? (
    <>
      {viewFirstInProgress && (
        <div className="cover_page_loader">
          <img className=" Loader" src="/gif/LoaderDot.gif" alt="" />
        </div>
      )}
      <div
        className="mb-4"
        onClick={() => {
          navigate("/TotalCommuPost");
        }}
      >
        <img src="/images/Back Arrow.svg" alt=""></img>
        <span className="published_hw_file_path1">
          &nbsp; Community Posts &nbsp;
        </span>
      </div>
      <div className=" d-flex align-items-center justify-content-between gap-2">
        <div className="d-flex align-items-center view_channel_headerBox gap-2 col-md-8 ">
          <div className="uploadImg_container">
            <img
              src={`${
                profilePicture
                  ? URL.createObjectURL(profilePicture)
                  : community?.profile_picture
                  ? `${IP}${community.profile_picture}`
                  : assets.CommunityImg
              }`}
              className="uploadImage view_first_upload_image"
              alt="uploadimg"
              onError={(e) => {
                e.target.src = assets.CommunityImg;
              }}
            />

            {!profilePicture && !community?.profile_picture ? (
              <>
                <input
                  type="file"
                  id="attachFileIcon"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    setEditCommunityDetails({
                      ...editCommunityDetails,
                      profilePicture: e.target.files[0],
                    });
                    handleProfilePictureChange(e.target.files[0]);
                  }}
                />
                <label htmlFor="attachFileIcon">
                  <img
                    src="/images/CameraIcon.png"
                    className="cameraIcon"
                    alt="cameraIcon"
                  />
                </label>
              </>
            ) : (
              <Popup
                on="click"
                trigger={
                  <img
                    onClick={() => setIsOpenedPopup(true)}
                    src="/images/CameraIcon.png"
                    className="cameraIcon"
                    alt="cameraIcon"
                  />
                }
                content={
                  isOpenedPopup && (
                    <div className="container_threedot">
                      <input
                        type="file"
                        id="attachFile"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          if (validateFileType(e.target.files[0])) {
                            setEditCommunityDetails({
                              ...editCommunityDetails,
                              profilePicture: e.target.files[0],
                            });
                            handleProfilePictureChange(e.target.files[0]);
                            setIsOpenedPopup(false);
                          } else {
                            toast.error("Invalid file format!!");
                          }
                        }}
                      />
                      <label htmlFor="attachFile" className="w-100">
                        <div className="PopupThreedots">Edit</div>
                      </label>
                      <div
                        onClick={(e) => {
                          setEditCommunityDetails({
                            ...editCommunityDetails,
                            profilePicture: null,
                          });
                          handleProfilePictureChange(null);
                          setIsOpenedPopup(false);
                        }}
                        className="PopupThreedots"
                      >
                        Remove
                      </div>
                    </div>
                  )
                }
                position="bottom center"
              />
            )}
          </div>

          <div
            className={`${
              editingMode ? `col-sm-7` : `col-sm-6`
            } channel_information d-flex flex-column w-100 `}
          >
            {!editingMode ? (
              <div className="d-flex align-items-center gap-2">
                <span className="view_channel_name">
                  {community?.community_name}
                </span>
                {community?.role !== "member" && (
                  <img
                    className="ml-2"
                    style={{ cursor: "pointer" }}
                    src="/images/editing_pencil.svg"
                    alt=""
                    onClick={() =>
                      setEditCommunityDetails({
                        ...editCommunityDetails,
                        editingMode: !editingMode,
                      })
                    }
                  />
                )}
              </div>
            ) : (
              <div className="community_description_edit w-100  my-2 px-2 py-1 d-flex justify-content-between">
                <input
                  className="edit_description w-100"
                  value={community_name}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.trim() !== "" || value === "") {
                      setEditCommunityDetails({
                        ...editCommunityDetails,
                        community_name: value,
                      });
                    }
                  }}
                  type="text"
                  maxLength={50}
                />
                <div
                  style={{ width: "180px" }}
                  className="yes_no gap-4 d-flex align-items-center"
                >
                  <div onClick={handleSubmit} className="done_discard  ">
                    <img src="/images/done.svg" alt="" />
                    <span>&nbsp; Done</span>
                  </div>

                  <div
                    className="done_discard "
                    onClick={() =>
                      setEditCommunityDetails({
                        ...editCommunityDetails,
                        community_name: cmtyName,
                        editingMode: !editingMode,
                      })
                    }
                  >
                    <img src="/images/discard.svg" alt="" />
                    <span>&nbsp; Discard</span>
                  </div>
                </div>
              </div>
            )}

            <div>
              <span className="view_created_by">
                Created by {community?.user_id?.name} &nbsp;
              </span>
              {community?.user_id?.id === teacher_id && (
                <span className="you">(You)</span>
              )}
            </div>
          </div>
          {/* {isPostCreated && (
            <div className=" p-2 view_post_successfull">
              <img src="/images/Success.png" alt="" />
              <span className="post_successfull_message">
                Your post has been posted successfully
              </span>
            </div>
          )}
          {isPostDeclined && (
            <div className=" p-2 view_post_successfull">
              <img src="/images/Success.png" alt="" />
              <span className="post_successfull_message">
                Post declined successfully.
              </span>
            </div>
          )} */}
        </div>
        <div className=" d-flex align-items-center justify-content-center view_search_pot_box  col-md-4">
          <div className=" d-flex justify-content-center ">
            <button
              className="btn btn-primary view_post_btn"
              onClick={(e) => setClickPost(true)}
            >
              Post to community
            </button>
          </div>

          {community?.role === "admin" && (
            <div className=" d-flex justify-content-center ">
              <button
                className="btn view_post_btn1"
                onClick={(e) => setClickDelete(true)}
              >
                Delete Channel
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="col-sm-8 p-0 d-flex align-items-center justify-content-between view_button_container">
        <button
          // className={`view_buttons_box ${active === "About" && "aboutActive"}`}
          className={`  poppins-semibold  ${
            active === "About" && "aboutActive"
              ? "active main_three_button_active orange-text poppins-semibold "
              : "main_three_button "
          }`}
          onClick={(e) => {
            setActive("About");
            localStorage.setItem("TypeClicked", "About");
          }}
        >
          About
        </button>
        <div
          // className={`d-flex view_buttons_box ${
          //   active === "Post" && "aboutActive"
          // }`}
          className={`  poppins-semibold  ${
            active === "Post" && "aboutActive"
              ? "active main_three_button_active orange-text poppins-semibold "
              : "main_three_button "
          }`}
          onClick={(e) => {
            setActive("Post");
            localStorage.setItem("TypeClicked", "Post");
          }}
        >
          <span>Posts</span>
          <span className="ml-1">
            (
            {community?.active_post_count + postRequestCount + postCreatedCount}
            )
          </span>
        </div>
        <button
          // className={` view_buttons_box ${
          //   active === "Member" && "aboutActive"
          // }`}
          className={`  poppins-semibold  ${
            active === "Member" && "aboutActive"
              ? "active main_three_button_active orange-text poppins-semibold "
              : "main_three_button "
          }`}
          onClick={(e) => {
            setActive("Member");
            localStorage.setItem("TypeClicked", "Member");
          }}
        >
          Members
        </button>
        <div
          // className={`d-flex view_buttons_box ${
          //   active === "Request" && "aboutActive"
          // }`}
          className={`  poppins-semibold  ${
            active === "Request" && "aboutActive"
              ? "active main_three_button_active orange-text poppins-semibold "
              : "main_three_button "
          }`}
          onClick={(e) => {
            setActive("Request");
            localStorage.setItem("TypeClicked", "Request");
          }}
        >
          <span>Requests</span>
          <span className="ml-1">
            ({/* {community?.request_post_count} */}
            {requestPostCountPending})
          </span>
        </div>
      </div>

      <div className="col-sm-12 flex-wrap my-2 d-flex justify-content-between ">
        <div className="col-md-8 p-0 m-0  ">
          {active === "About" && (
            <AboutChannel
              setViewFirstInProgress={setViewFirstInProgress}
              setEditCommunityDetails={setEditCommunityDetails}
              editCommunityDetails={editCommunityDetails}
              community={community}
            />
          )}

          {active === "Post" &&
          (community?.active_post_count > 0 ||
            postRequestCount ||
            postCreatedCount) ? (
            <div
              id="single-post-image-scroll"
              className="view_post_box orange-scrollBar"
            >
              <SinglePostImage
                isPostCreated={isPostCreated}
                communityId={state.communityId}
                setIsPostCreated={setIsPostCreated}
                community={community}
                setReRenderPage={setReRenderPage}
                reRenderPage={reRenderPage}
              />
            </div>
          ) : (
            active === "Post" && (
              <div className="view_no_post_msg mt-3">
                No posts yet. Be the first one to add a post to community.
              </div>
            )
          )}
          {/* {click1 && <ChannelPost communityId={communityId} />} */}
          {active === "Member" && (
            <div className="view_member_box orange-scrollBar">
              <ChannelMember
                setIsMemberUpdated={setIsMemberUpdated}
                isMemberUpdated={isMemberUpdated}
                community={community}
              />
            </div>
          )}

          {active === "Request" ? (
            <div
              id="single-channel-request-scroll"
              className="view_post_box orange-scrollBar"
            >
              <SingleChannelRequest
                setPostRequestCount={setPostRequestCount}
                setRejectedPostCount={setRejectedPostCount}
                communityId={state.communityId}
                setIsPostCreated={setIsPostCreated}
                setIsPostDeclined={setIsPostDeclined}
                getCommuntiy={getCommuntiy}
                // setRequestPostCountPending={setRequestPostCountPending}
                setRequestPostCountRejected={setRequestPostCountRejected}
              />
            </div>
          ) : (
            // <div className="view_no_post_msg mt-3">No Any Request Yet.</div>
            <></>
          )}
        </div>

        <div className="col-md-4  mt-2">
          <div className="mb-2 d-flex align-items-center justify-content-between">
            <span className="channel_header">Channels</span>

            <span
              className="create_channel_btn"
              onClick={(e) => {
                setClickCreate(true);
                localStorage.setItem("TEACHER_OPTIONS_STORAGE_KEY", []);
              }}
            >
              + Create Channel
            </span>
          </div>
          <div className="view_channel_boxs orange-scrollBar overflow-auto">
            {communitybyID &&
              communitybyID.length > 0 &&
              communitybyID.map((data, idx) => (
                <ChannelBox
                  key={idx}
                  setViewFirstInProgress={setViewFirstInProgress}
                  postCreatedCount={postCreatedCount}
                  viewFirstInProgress={viewFirstInProgress}
                  postRequestCount={postRequestCount}
                  communityData={data}
                  setActive={setActive}
                />
              ))}
          </div>
        </div>
      </div>
      {clickDelete && (
        <DeleteChnnelConfir
          setClickDelete={setClickDelete}
          communityId={state.communityId}
          community={community}
        />
      )}
      {clickCreate && <CreateChannelFirst change={setClickCreate} />}
      {clickPost && (
        <CreatePostFirst
          clickPost={clickPost}
          isInsideOfCommunity={true}
          setClickPost={setClickPost}
          communityData={community}
          setIsPostCreated={setIsPostCreated}
          setPostCreatedCount={setPostCreatedCount}
          setReRenderPage={setReRenderPage}
        />
      )}
    </>
  ) : (
    <>
      <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
    </>
  );
};

export default ViewFirstScreen;
